module.exports = __webpack_public_path__ + "static/media/ftp_7zone.0d08cd3c.png";